import {getCommonRoutes} from './commonRoutes';

export const getPagesRoutes = (user, permissionObj = {}) => {
  // const isUserAdmin = user?.derivedData?.isAdmin || false;

  return [...getCommonRoutes(permissionObj)];
};
